
<span>{{item.nummer}}</span>
<span *ngIf="item.subnummer > 0">/{{item.subnummer}}</span>
<span> - {{item.kurzbez}}</span>
